
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {CustomLink} from "theme/components/shared/common/CustomLink";


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "rest-api"
    }}>{`REST API`}</h1>
    <ol>
      <li parentName="ol">
        <CustomLink href="http://atlas.apache.org/api/v2/index.html" mdxType="CustomLink">REST API Documentation</CustomLink>
      </li>
      <li parentName="ol">
        <CustomLink href="http://atlas.apache.org/api/rest.html" mdxType="CustomLink">Legacy API Documentation </CustomLink>
      </li>
    </ol>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;